import classes from "../classes";
import expandable from "./higher-order/expandable";
import React from "react";
import pure from "./higher-order/pure";
import SideFilters from "../containers/side-filters";
import SideFiltersSummary from "../containers/side-filters-summary";
import tournamentTabs from "../tournament-tabs";

export default expandable(pure(function SideFiltersContainer({ children, expanded, list, location, session, tags, toggle, tournaments }) {
  var hasNoAddress = session.getIn(["billing_address", "state"]) === null;
  var canPlayForMoney = session.get("abilities").contains("enter cash contests") || hasNoAddress;
  var alertMessage = (!canPlayForMoney) ? "Residents of your state are only allowed to play Free Points Tournaments." : "";

  return (
    <div className={classes({
      "filters": true,
      "filters--is-open": expanded
    })}>
      <p className="alert-message text-center">
        {alertMessage}
      </p>

      <h1 className="filters_heading">
        {titleForList(list, tags)}
      </h1>

      <SideFilters list={list} location={location} tournaments={tournaments} />

      <div className="filters_pane">
        <button className="filters_action-close" onClick={toggle} type="button" />

        <div className="filters_subheading">
          <button className="filters_action_toggle" onClick={toggle} type="button">
            <i className="dw-filter dw--1-5x" />
          </button>

          <SideFiltersSummary list={list} location={location} tournaments={tournaments} />
        </div>

        {children}
      </div>
    </div>
  );
}));

function titleForList(list, tags) {
  var tab = tournamentTabs[list];
  if (tab) {
    return tab.title + " Tournaments";
  }
  var tag = tags.valueSeq().find(t => t.get("name") === list);
  if (tag) {
    return tag.get("title");
  }
  return null;
}
